import React from "react";
import { useSortBy, useTable } from "react-table";
import { motion } from "framer-motion";
import { BiServer } from "react-icons/bi";
import { Table, Thead, Tr, Th, Tbody, Td, Center, Text } from "@chakra-ui/react";

import { Spinner } from "../../components/Loader";
const MotionRow = motion(Tr);

export default function ReactTable({ background = "gray.50", color = "gray.800", columns, ...props }) {
	let { data, isLoading } = props;

	const memorizedData = React.useMemo(() => (data ? data : [{}]), [data]);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
		{
			columns,
			data: memorizedData || [],
		},
		useSortBy
	);

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<Table p={8} {...getTableProps()} size="sm" variant="simple">
					{rows.length > 0 ? (
						<>
							<Thead zIndex="2" pos="sticky" top="0" bg={background}>
								{headerGroups.map((headerGroup) => (
									<Tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<Th py="4" {...column.getHeaderProps(column.getSortByToggleProps())} color={color}>
												{column.render("Header")}
												<span>{column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}</span>
											</Th>
										))}
									</Tr>
								))}
							</Thead>
							<Tbody {...getTableBodyProps()}>
								{rows.map((row) => {
									prepareRow(row);
									return (
										<MotionRow
											initial={{ opacity: 0 }}
											animate={{ opacity: 1 }}
											transition={{ duration: 0.2 }}
											cursor="pointer"
											_hover={{ bg: "gray.50" }}
											{...row.getRowProps()}
										>
											{row.cells.map((cell) => (
												<Td pos="unset !important" style={{ cursor: "default" }} py="2" {...cell.getCellProps()}>
													{cell.render("Cell")}
												</Td>
											))}
										</MotionRow>
									);
								})}
							</Tbody>
						</>
					) : (
						<Center pos="absolute" top="50%" right="50%" flex="1" color="gray.400">
							<BiServer size="1.1rem" /> <Text fontSize="md">&nbsp;No data.</Text>
						</Center>
					)}
				</Table>
			)}
		</>
	);
}
